import { render } from "./MyGameLog.vue?vue&type=template&id=671ec3ec"
import script from "./MyGameLog.vue?vue&type=script&lang=js"
export * from "./MyGameLog.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__